import { render, staticRenderFns } from "./DuelsStats.vue?vue&type=template&id=49f95043&scoped=true"
import script from "./DuelsStats.vue?vue&type=script&lang=js"
export * from "./DuelsStats.vue?vue&type=script&lang=js"
import style0 from "./DuelsStats.vue?vue&type=style&index=0&id=49f95043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f95043",
  null
  
)

export default component.exports